import { t } from "@/i18n-js/instance";
import { Button } from "@circle-react-uikit/Button";
import { Modal } from "@circle-react-uikit/ModalV2";
import { Typography } from "@circle-react-uikit/Typography";
import { Loader } from "./Loader";
import { useBlockPlanTrialDowngrade } from "./hooks/useBlockPlanTrialDowngrade";

const i18nRoot = "pricing_plans.upgrade_modal.block_plan_trial_downgrade";

export const BlockPlanTrialDowngrade = () => {
  const {
    isLoading,
    planTrialEndDateFormatted,
    planTrialDaysLeft,
    handleContactSupportOnClick,
  } = useBlockPlanTrialDowngrade();

  if (isLoading) {
    return <Loader title={t("pricing_plans.upgrade_modal.loading.loading")} />;
  }

  return (
    <>
      <Modal.Header>
        <Modal.Title>{t([i18nRoot, "title"])}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="flex flex-col items-center gap-4">
          <Typography.BodyMd>
            {t([i18nRoot, "description"], {
              days: planTrialDaysLeft,
              date: planTrialEndDateFormatted,
            })}
          </Typography.BodyMd>
          <Typography.BodyMd>{t([i18nRoot, "explanation"])}</Typography.BodyMd>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="flex flex-row justify-end">
          <Button variant="primary" onClick={handleContactSupportOnClick}>
            {t([i18nRoot, "button"])}
          </Button>
        </div>
      </Modal.Footer>
    </>
  );
};
